var _style, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 339.5 133.9",
    style: {
      enableBackground: "new 0 0 339.5 133.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.207,
    y1: 940.1896,
    x2: 54.207,
    y2: 1017.3676,
    gradientTransform: "matrix(1 0 0 1 0 -891.8677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F88F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F26E55"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,9.5h25.6v48.2l45-48.2H104L52.4,63.4l56,62.1H72.7l-47.1-55v55H0V9.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.7063,
    y1: 940.1896,
    x2: 170.7063,
    y2: 1017.3676,
    gradientTransform: "matrix(1 0 0 1 0 -891.8677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F88F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F26E55"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.3,9.5h38.3c9.3,0,18.1,1,26.4,3.1s15.6,5.4,21.8,10.1c6.3,4.6,11.1,10.7,14.8,18.1s5.5,16.4,5.5,27 c0,9.4-1.7,17.6-5.3,24.8c-3.6,7.1-8.3,13.1-14.3,18c-6,4.9-13,8.5-20.8,11c-7.8,2.5-16.1,3.7-24.7,3.7h-41.7V9.5L117.3,9.5z  M142.8,101.9h13.3c5.9,0,11.4-0.6,16.4-1.8c5-1.2,9.5-3.2,13.2-6c3.7-2.8,6.6-6.4,8.8-11c2.1-4.5,3.2-10.1,3.2-16.6 c0-5.7-1-10.6-3.2-14.8c-2.1-4.2-5-7.7-8.6-10.4c-3.6-2.7-7.8-4.8-12.7-6.2c-4.9-1.4-10-2.1-15.3-2.1h-15L142.8,101.9L142.8,101.9 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.4668,
    y1: 940.0937,
    x2: 286.4668,
    y2: 1017.0956,
    gradientTransform: "matrix(1 0 0 1 0 -891.8677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F88F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F26E55"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M339.2,114.6c-7.1,3.7-14.7,6.4-22.4,8.1c-7.8,1.7-15.7,2.5-23.8,2.5c-8.6,0-16.6-1.4-23.8-4 c-7.3-2.7-13.6-6.5-18.9-11.6c-5.3-5-9.5-11.1-12.4-18.3c-3-7.1-4.4-15.1-4.4-23.9s1.5-16.8,4.4-23.9s7.1-13.2,12.4-18.3 c5.3-5,11.6-8.9,18.9-11.6s15.2-4,23.9-4c8.9,0,17,1,24.4,3.2c7.4,2.1,14,5.7,19.6,11l-17.1,18.7c-3.3-3.4-7-6-11.2-7.7 c-4.2-1.7-9.4-2.6-15.6-2.6c-5.2,0-9.9,0.9-14.1,2.6c-4.2,1.7-7.8,4.3-10.9,7.4c-3,3.1-5.3,7-7,11.3c-1.7,4.3-2.4,9-2.4,14.2 c0,5.2,0.8,9.9,2.4,14.3c1.7,4.3,3.9,8,7,11.2c3,3.1,6.6,5.7,10.9,7.4c4.2,1.7,9,2.6,14.1,2.6c5.3,0,9.9-0.6,13.7-1.8 c3.8-1.2,7-2.4,9.2-3.7V79.8h-19.8V57.2h43.2v57.5H339.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo-new.a6982963339c87cc8f5f7dededfe1667.svg";
export { ForwardRef as ReactComponent };